<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<div *blockUI="'login'" class="container">
	<div class="sign-in-container">
		<div>
			<div class="login-logo text-align-center">
				<img src="/assets/images/inverselogo.svg" alt="Logo" />
			</div>

			<form class="login-form" id="form" [formGroup]="dataForm" (ngSubmit)="onSubmit()" novalidate *ngIf="showLoginForm">
				<mat-card class="card-info" *ngIf="loginInfo">
					<mat-card-content>
						{{ loginInfo }}
					</mat-card-content>
				</mat-card>
				<mat-card>
					<mat-card-content>
						<mat-form-field>
							<mat-label>Email Address</mat-label>
							<input formControlName="username" matInput (change)="onEmailAddressChanged()" />
							<mat-error *ngIf="username.touched && username.errors?.required"> Email Address is required. </mat-error>
							<mat-error *ngIf="username.touched && username.errors?.maxlength"> Email must be no more than 256 characters </mat-error>
							<mat-error *ngIf="username.touched && username.errors?.pattern && !username.errors?.maxlength">
								Email must be a correctly formatted email address
							</mat-error>
						</mat-form-field>
						<div class="inputReservedSpace">
							<mat-form-field *ngIf="usePasswordField">
								<mat-label>Password</mat-label>
								<input formControlName="password" matInput type="password" />
								<mat-error *ngIf="password.touched && password.errors?.required"> Password is required. </mat-error>
							</mat-form-field>
						</div>
						<div class="forgotPasswordContainer">
							<a (click)="forgotPassword($event)"> Forgot password? </a>
						</div>
						<div class="login-actions">
							<button class="submitBtn" mat-raised-button type="submit" color="primary">Sign in</button>
							<button *ngIf="!showCreateUserAccountForm" mat-raised-button (click)="createUserAccount($event)">Create User Account</button>
						</div>
					</mat-card-content>
				</mat-card>
			</form>

			<mat-card id="OtpForm" *ngIf="showOtpForm">
				<mat-card-content>
					<otp #otpForm (submitOtp)="onSubmitOtp($event)" (resendOtp)="onResendOtp($event)"></otp>
				</mat-card-content>
			</mat-card>

			<mat-card id="CreateUserAccountForm" *ngIf="showCreateUserAccountForm">
				<mat-card-content>
					<organiser-create-form
						(inactiveOrganiserUserAccountCreated)="onInactiveOrganiserUserAccountCreated($event)"
					></organiser-create-form>
				</mat-card-content>
			</mat-card>

			<mat-card id="ForgotPasswordForm" *ngIf="showForgotPasswordForm" class="forgot-password-card">
				<mat-card-content>
					<forgot-password-form></forgot-password-form>
				</mat-card-content>
			</mat-card>

			<div [hidden]="!showResetPasswordForm">
				<mat-card id="ResetPasswordForm"  class="reset-password-card">
					<mat-card-content>
						<reset-password-form #resetPasswordForm></reset-password-form>
					</mat-card-content>
				</mat-card>
			</div>

			<mat-card class="card-error" *ngIf="isError">
				<mat-card-content>
					{{ serverErrorMessage }}
				</mat-card-content>
			</mat-card>

			<mat-card class="card-error" *ngIf="showLinkExpiredError">
				<mat-card-content>
					<p>Your link has expired.</p>
					<button mat-raised-button color="primary" (click)="reset()">Sign In</button>
				</mat-card-content>
			</mat-card>

			<mat-card id="AppInfo" *ngIf="showAppInfo">
				<mat-card-content>
					App Info: {{ appVersion }}<br />
					Api Info: {{ apiInfo?.version }} [{{ apiInfo?.url }}]
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>
